export default __webpack_public_path__ + "static/media/4O4.daef4cb9.png";